let ListUtils = {};

ListUtils.shuffle = (array) => {

  if (!array || !(array instanceof Array))
    throw new Error('Not an array');

  if (array.length === 0)
    return [];

  let counter = array.length, temp, index;

  // While there are elements in the array
  while (counter--) {
    // Pick a random index
    index = (Math.random() * counter) | 0;

    // And swap the last element with it
    temp = array[counter];
    array[counter] = array[index];
    array[index] = temp;
  }

  return array;

};

module.exports = ListUtils;


// WEBPACK FOOTER //
// ./src/js/services/ListUtils.js